<script setup lang="ts">
import { ref } from 'vue'
import MatchmakingForm from '@/components/form/MatchmakingForm.vue'
import AppLink from '@/components/app/AppLink.vue'
import type { MatchmakingPost } from '~/types/types'
useSeoMeta({
  title: () => `Drivmedla - Skapa ett inlägg`,
  description: () =>
    'Skapa ett inlägg där du berättar vad du erbjuder eller vad du letar efter så att andra kan hitta dig och ni tillsammans kan komma vidare i omställningen.',
  ogTitle: () => `Drivmedla - Skapa ett inlägg`,
  ogDescription: () =>
    'Skapa ett inlägg där du berättar vad du erbjuder eller vad du letar efter så att andra kan hitta dig och ni tillsammans kan komma vidare i omställningen.',
  ogLocale: () => 'sv_SE',
  ogSiteName: () => 'Drivmedla',
  ogUrl: () => `${useRuntimeConfig().public.baseURL}${useRoute().fullPath}`,
  ogImage: () => `${useRuntimeConfig().public.baseURL}/_nuxt/assets/_logo-horizontal-GREEN.svg`,
})

const { create } = useStrapi()
const matchmakingForm = ref<typeof MatchmakingForm>()
const visible = ref(false)
const submitInProgress = ref(false)
const onSubmit = async (values: MatchmakingPost) => {
  try {
    submitInProgress.value = true
    const createMatchmaking = await create<MatchmakingPost>('matchmakings', values)
    submitInProgress.value = false
    if (createMatchmaking) visible.value = true
    matchmakingForm.value?.resetForm()
  } catch (error) {
    console.error(error)
  }
}
</script>
<template>
  <main>
    <AppHero title="Skapa inlägg">
      <p>
        Skapa ett inlägg där du berättar vad du erbjuder eller vad du letar efter så att andra kan
        hitta dig.
      </p>
      <AppLink class="link-back" title="Alla inlägg" path="/samarbeta" icon="ArrowLeftIcon" />
    </AppHero>
    <LayoutSection size="small">
      <MatchmakingForm ref="matchmakingForm" @form-submitted="onSubmit" />
      <AppLoadingWrapper :is-loading="submitInProgress" :height="50"> </AppLoadingWrapper>
    </LayoutSection>
    <Dialog v-model:visible="visible" :closable="false" class="modal">
      <div class="modal__content align-items-center">
        <h2>Tack för att du vill vara med och ställa om</h2>
        <p>
          Innan ditt inlägg publiceras behöver det <strong>verifieras</strong>. Verifieringen görs
          via ett mail som precis skickats till den e-post som angavs i inlägget.
        </p>
        <p>I mailet finns också intruktioner om hur du kan redigera eller ta bort ditt inlägg.</p>

        <AppLink class="link-back" title="Tillbaka" path="/samarbeta" icon="ArrowLeftIcon" />
      </div>
    </Dialog>
  </main>
</template>
<style lang="scss">
@import 'App.scss';

.modal {
  background-color: #fff;
  padding: 0;
  max-width: 100%;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  justify-content: center;
  align-items: center;

  &__content {
    display: flex;
    margin: 0 auto;
    text-align: center;
    flex-direction: column;
    width: 50%;
  }
}

.formkit-form {
  .formkit-outer {
    width: 300px;
    max-width: 50%;
  }

  .formkit-inner .p-calendar .p-inputtext,
  .p-dropdown {
    width: 300px;
  }
  [data-invalid] .formkit-inner {
    border-color: red;
    box-shadow: 0 0 0 1px red;
  }
  .required-field::after {
    content: ' *';
    color: red;
  }
  .terms-checkbox {
    width: auto;
    max-width: 100%;
    margin-bottom: -30px;
    .formkit-wrapper {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
      .formkit-label {
        white-space: nowrap;
        margin-left: 0.5rem;
        padding: 0;
      }
    }
    .formkit-messages {
      margin-top: -16px;
      margin-bottom: 20px;
    }
  }
}
</style>
